import {useEffect, useState} from 'react';
import {Link, Outlet} from 'react-router';

import KyError from '../components/Errors/KyError';
import Loading from '../components/Loading';
import useAppContext from '../conf/AppContext';

export default function Restricted() {
  const appContext = useAppContext();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        const rez = await appContext.api.get('api/v1/users/profile', {
          parseJson: true,
        });
        setData(rez);
      } catch (err) {
        if (err?.response?.status === 401) {
          localStorage.clear();
        }
        setError(err);
      }
    };
    loadData();
  }, []);
    
  let body = <Loading />;
  if (data) {
    if (data.data.user.role === 'ADMIN' || data.data.user.role === 'SUPER_ADMIN') {
      return <Outlet />;
    } else {
      return (
        <div className="container py-5" style={{marginTop: '100px'}}>
          <div className="row">
            <div className="col-md-2 text-center">
              <p>
                <i className="bi bi-exclamation-octagon text-warning" style={{fontSize: '50px'}} /><br />
                Status Code: 403
              </p>
            </div>
            <div className="col-md-10">
              <h3>ACCESS DENIED</h3>
              <p>Access to this page is denied due to lack of permissions.</p>
              <Link to="/" className="btn btn-primary">Go Back To Home</Link>
            </div>
          </div>
        </div>
      );
    }
    
  } else if (error) {
    body = <KyError kyError={error} />;
  }
    
  return (
    <div>{body}</div>
  );
}
